import styles from './styles.module.css';
import React, { useContext } from 'react';
import { Icon } from '../../index';
import { Icons } from '../../Icon/Icon';
import { SelectionRowContext } from '../../../context';

export interface SelectionLayoutRowWrapperProps {
    children?: React.ReactNode;
    isSecondary?: boolean;
    afterRow?: React.ReactNode;
    onClick?: any;
    showIcon?: boolean;
    type?: string;
    selectedCountry?: string;
}
const SelectionLayoutRowWrapper = ({
    isSecondary = false,
    children,
    afterRow,
    onClick,
    type,
    showIcon = true,
    selectedCountry: initialSelectedCountry,
}: SelectionLayoutRowWrapperProps) => {
    const { selectedCountry } = useContext(SelectionRowContext);

    return (
        <div className={`${styles.containerRow} ${isSecondary ? styles.secondary : ''}`} onClick={onClick}>
            {showIcon && type && (
                <div className={styles.typeIcon}>
                    {/* @ts-ignore */}
                    <Icon icon={Icons[type]} />
                </div>
            )}

            {children}

            {!!afterRow && <div className={styles.containerRowAfter}>{afterRow}</div>}
        </div>
    );
};

export default SelectionLayoutRowWrapper;
